import ReturnsNotificationFashion from '../../../../../pages/vip/features/returns-notification/returns-notification-fashion';

export default ReturnsNotificationFashion;
